import { imageAssets } from './content/imageAssets';

export interface CaseStudy {
  id: string;
  title: string;
  category: string;
  client: string;
  description: string;
  challenge: string;
  solution: string;
  results: string[];
  technologies: string[];
  image: string;
  projectUrl?: string;
  projectType: 'showcase' | 'real-world';
}

export const caseStudies: CaseStudy[] = [
  {
    id: 'cleaning-edge-platform',
    title: 'Cleaning EDGE Platform',
    category: 'Web Development',
    client: 'Cleaning EDGE',
    description: 'A comprehensive digital platform for managing cleaning services, including scheduling, team management, and customer feedback.',
    challenge: 'The client needed a scalable solution to manage their growing cleaning service operations, handle customer bookings, and optimize team scheduling across multiple locations.',
    solution: 'We developed a custom web platform that integrates booking management, team scheduling, and real-time tracking. The solution includes a customer portal, admin dashboard, and mobile-friendly interface for cleaning teams.',
    results: [
      'Reduced scheduling conflicts by 95%',
      'Increased customer satisfaction rate to 98%',
      'Improved team efficiency by 40%',
      'Enabled expansion to 3 new locations'
    ],
    technologies: ['React', 'Node.js', 'PostgreSQL', 'Stripe', 'Google Maps API'],
    image: imageAssets.caseStudies.cleaningEdgePlatform,
    projectUrl: 'https://cleaningedge.ca',
    projectType: 'real-world'
  },
  {
    id: 'ai-analytics-dashboard',
    title: 'AI-Powered Analytics Dashboard',
    category: 'AI Solutions',
    client: 'TechVision Inc.',
    description: 'Custom analytics dashboard using machine learning to predict business trends and optimize operations.',
    challenge: 'The client struggled to make sense of their vast data collection and needed predictive insights to make better business decisions.',
    solution: 'We implemented a machine learning system that analyzes historical data, predicts trends, and provides actionable insights through an intuitive dashboard interface.',
    results: [
      'Increased prediction accuracy by 85%',
      'Reduced decision-making time by 60%',
      'Generated $2M in cost savings',
      'Improved inventory management by 45%'
    ],
    technologies: ['Python', 'TensorFlow', 'React', 'D3.js', 'AWS'],
    image: imageAssets.caseStudies.aiAnalyticsDashboard,
    projectType: 'showcase'
  },
  {
    id: 'global-marketing-campaign',
    title: 'Global Marketing Campaign',
    category: 'Marketing Strategy',
    client: 'Global Solutions Ltd',
    description: 'Comprehensive digital marketing strategy that increased client\'s market presence across three continents.',
    challenge: 'The client needed to expand their market presence globally while maintaining consistent brand messaging and engagement across different cultural contexts.',
    solution: 'We developed a multi-channel marketing strategy with localized content, targeted advertising, and cultural adaptation of marketing materials.',
    results: [
      'Reached 2M+ new potential customers',
      'Increased global sales by 150%',
      'Improved brand recognition by 80%',
      'Generated 300% ROI on marketing spend'
    ],
    technologies: ['HubSpot', 'Google Analytics', 'Adobe Creative Suite', 'Social Media APIs'],
    image: imageAssets.caseStudies.globalMarketingCampaign,
    projectType: 'showcase'
  },
  {
    id: 'haunted-galleria',
    title: 'Haunted Galleria',
    category: 'Web Design & Development',
    client: 'Haunted Galleria',
    description: 'An immersive, dark-themed showcase website for a haunted gallery experience — blending atmospheric visuals, eerie animations, and bold typography to captivate visitors.',
    challenge: 'The client needed a web presence that matched the dramatic, mysterious nature of their haunted gallery concept — one that felt genuinely unsettling and memorable rather than generic.',
    solution: 'We crafted a fully custom site with dark ambient aesthetics, layered parallax effects, and horror-inspired typography. Every detail — from hover states to page transitions — was designed to build suspense and intrigue.',
    results: [
      'Created a stand-out brand identity in a niche market',
      'Immersive UX that keeps visitors engaged longer',
      'Fully responsive across all devices',
      'Optimized for fast load times despite rich visual effects',
    ],
    technologies: ['React', 'Tailwind CSS', 'Framer Motion', 'Vite'],
    image: imageAssets.caseStudies.hauntedGalleria,
    projectUrl: 'https://hauntedgalleria.impresstars.com',
    projectType: 'showcase'
  }
];